import { getJavaRequest } from "@tipico/java-streams";
import * as React from "react";

export const GOOGLE_ANALYTICS_INITIAL_DATA = "GoogleAnalyticsInitialState";
export const USER_ID = "GoogleAnalyticsUserChanged";

export interface GoogleDataLayerApi {
    initialGoogledata: GoogleAnalyticsInitialState;
    push(
        googleTagManagerParameters: GoogleTagManagerActiveUser &
            GoogleTagManagerParameters &
            EventParameters & { initialGoogledata: GoogleAnalyticsInitialState }
    ): void;
}

export interface GoogleAnalyticsInitialState {
    machineId: number;
    shopId: number;
    regionId: string;
    retailTrackingMeasurementEnabledForWeb: boolean;
}

export interface GoogleTagManagerActiveUser {
    userID: string;
}

export interface GoogleTagManagerParameters {
    cid: string;
    uid: string;
    event: string;
    eventAction: EventAction;
    eventCategory: EventCategory;
    eventLabel: EventLabel;
}

export interface EventParameters {
    eventAction: EventAction;
    eventCategory: EventCategory;
    eventLabel: EventLabel;
}
export enum EventAction {
    ButtonClick = "ButtonClickWeb"
}

export enum EventCategory {
    MainButton = "MainButtonWeb"
}

export enum EventLabel {
    Bets = "Bets",
    Results = "Results",
    LiveBets = "Live-Bets"
}

export type DataLayer = GoogleDataLayerApi & GoogleTagManagerActiveUser;

export type TrackEvent = (
    eventActionEnum: EventAction,
    eventCategoryEnum: EventCategory,
    eventLabelEnum: EventLabel
) => void;

export const GoogleTackingContext = React.createContext<TrackEvent>(() => {
    // no implementation needed
});

export default function createGoogleAnalytics(
    dataLayer: DataLayer
): TrackEvent {
    getJavaRequest<string>(USER_ID).subscribe(
        userID => (dataLayer.userID = userID)
    );
    getJavaRequest<GoogleAnalyticsInitialState>(
        GOOGLE_ANALYTICS_INITIAL_DATA
    ).subscribe(intialGoogledataInput => {
        dataLayer.initialGoogledata = intialGoogledataInput;
    });

    return (eventActionEnum, eventCategoryEnum, eventLabelEnum) => {
        if (
            !dataLayer ||
            !dataLayer.initialGoogledata ||
            !dataLayer.initialGoogledata.retailTrackingMeasurementEnabledForWeb
        ) {
            return;
        }
        if (dataLayer.userID == null) {
            dataLayer.userID = "anonymous";
        }
        dataLayer.push({
            cid: dataLayer.userID,
            event: "clickAction",
            eventAction: eventActionEnum,
            eventCategory: eventCategoryEnum,
            eventLabel: eventLabelEnum,
            initialGoogledata: dataLayer.initialGoogledata,
            uid: dataLayer.userID,
            userID: dataLayer.userID
        });
    };
}
